import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    text: `"Shambhu Cabs provided an excellent ride experience. The driver was polite, punctual, and the car was very clean. Highly recommended!"`,
    img: "/img/testimonial1.jpg",
    name: "Mr. Rajesh Kumar",
    role: "Customer"
  },
  {
    text: `"I booked an airport drop early in the morning. The driver arrived on time and the ride was very smooth. Shambhu Cabs is my go-to service now."`,
    img: "/img/testimonial2.jpg",
    name: "Ms. Priya Sharma",
    role: "Customer"
  },
  {
    text: `"Very reliable and affordable service. I booked for hospital visits and the driver was very helpful throughout the journey. Truly appreciated!"`,
    img: "/img/testimonial3.jpg",
    name: "Mr. Anil Verma",
    role: "Customer"
  },
  {
    text: `"The full city tour experience was fantastic! The driver guided us well and made the day memorable. Great service by Shambhu Cabs."`,
    img: "/img/testimonial4.jpg",
    name: "Ms. Kavita Patel",
    role: "Customer"
  }
];

const TestimonialSlider = () => {
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <section className="gauto-testimonial-area section_70">
      <div className="container">

        <div className="row">
          <div className="col-md-12">
            <div className="site-heading">
              <h4>What Our Customers Say</h4>
              <h2>Testimonials</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <Slider {...settings} className="testimonial-slider">

              {testimonials.map((t, i) => (
                <div className="single-testimonial" key={i}>
                  <div className="testimonial-text">
                    <p>{t.text}</p>

                    <div className="testimonial-meta">
                      {/* <div className="client-image">
                        <img src={t.img} alt={t.name} />
                      </div> */}

                      <div className="client-info">
                        <h3>{t.name}</h3>
                        <p>{t.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </Slider>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TestimonialSlider;
